import http from "@/utils/http";

export async function set_fcm_token(data) {
    const req = (await http.post(`/notification/token`, data));
    return req.data;
}

export async function get_notifications() {
    const req = (await http.get(`/notification`));
    return req.data;
}

export async function get_unread_notification_counts() {
    const req = (await http.get(`/notification/unread-counts`));
    return req.data;
}

export async function read_notifications(data) {
    const req = (await http.put(`/notification/markasread`, data));
    return req.data;
}

export async function mark_resource_notifications_read(data) {
    const req = (await http.put(`/notification/mark-resource-read`, data));
    return req.data;
}
